import script from "./consultingInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./consultingInfo.vue?vue&type=script&setup=true&lang=js"

import "./consultingInfo.vue?vue&type=style&index=0&id=788c41fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788c41fe"]])

export default __exports__